import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import {removeProfile, loadIdToken, removeIdToken} from 'Utils/jwtUtil';

// Components
import {IconButton, Grid} from '@material-ui/core';
import Navigation from 'Components/common/Navigation';
import NavigationItem from 'Components/common/NavigationItem';
import {
    updateF1OrderReceiveSearchList,
    updateF1OrderListSearchFields,
} from 'Actions/host';

// Actions
import {T} from 'Actions/translate';
import {openNotification} from 'Actions/notification';

// Icons
import {
    ArrowBackIos,
    ShoppingCartOutlined,
    PersonOutlineOutlined,
    AddShoppingCart,
    Home,
    HelpOutline,
} from '@material-ui/icons';

class Header extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired,
    };

    componentDidMount() {
        if (
            document.getElementById('header-container') &&
            document.getElementById('header-background')
        ) {
            document.getElementById('header-background').style.height =
                document.getElementById('header-container').clientHeight + 'px';
        }
        window.onload = function () {
            if (
                document.getElementById('header-container') &&
                document.getElementById('header-background')
            ) {
                document.getElementById('header-background').style.height =
                    document.getElementById('header-container').clientHeight +
                    'px';
            }
        };
    }

    componentDidUpdate() {
        let currentMsg = this.props.msg;
        let suppyleCenterID = this.props.currentSupplyCenterId;
        if (
            typeof currentMsg !== 'undefined' &&
            currentMsg &&
            currentMsg === '网络异常，请检查您的网络'
        ) {
            window.onload = function () {
                if (
                    document.getElementById('header-container') &&
                    document.getElementById('header-background')
                ) {
                    document.getElementById('header-background').style.height =
                        document.getElementById('header-container')
                            .clientHeight + 'px';
                }
            };
        } else {
            window.onload = function () {
                if (
                    document.getElementById('header-container') &&
                    document.getElementById('header-background')
                ) {
                    if (
                        typeof suppyleCenterID !== 'undefined' &&
                        suppyleCenterID === -1
                    ) {
                        // document.getElementById(
                        //     'header-background',
                        // ).style.height = 5.3 + 'rem';
                    } else {
                        document.getElementById(
                            'header-background',
                        ).style.height =
                            document.getElementById('header-container')
                                .clientHeight + 'px';
                    }
                }
            };
        }
    }

    componentWillReceiveProps() {
        let suppyleCenterID = this.props.currentSupplyCenterId;
        if (this.props.isShoppingCart) {
            if (this.props.cartActivity && this.props.cartActivity.id) {
                if (
                    document.getElementById('header-container') &&
                    document.getElementById('header-background')
                ) {
                    if (
                        typeof suppyleCenterID !== 'undefined' &&
                        suppyleCenterID === -1
                    ) {
                        // document.getElementById(
                        //     'header-background',
                        // ).style.height = 5.3 + 'rem';
                    } else {
                        document.getElementById(
                            'header-background',
                        ).style.height = 12 + 'rem';
                    }
                }
            } else {
                if (
                    document.getElementById('header-container') &&
                    document.getElementById('header-background')
                ) {
                    if (
                        typeof suppyleCenterID !== 'undefined' &&
                        suppyleCenterID === -1
                    ) {
                        // document.getElementById(
                        //     'header-background',
                        // ).style.height = 5.3 + 'rem';
                    } else {
                        document.getElementById(
                            'header-background',
                        ).style.height =
                            document.getElementById('header-container')
                                .clientHeight -
                            20 +
                            10 +
                            'px';
                    }
                }
            }
        }
    }

    shoppingCartEvent = () => {
        const {localData} = this.props;

        if (localData.customerEmail) {
            if (this.props.shoppingCartEvent) {
                this.props.shoppingCartEvent();
            } else {
                if (
                    this.props.history.location.pathname.toLocaleLowerCase() ===
                    '/purchase/shoppingCart'.toLocaleLowerCase()
                ) {
                    this.props.history.replace('/purchase/shoppingCart');
                } else {
                    this.props.history.push('/purchase/shoppingCart');
                }
            }
        } else {
            if (this.props.shoppingCartEvent) {
                this.props.shoppingCartEvent();
            }
        }
    };

    shoppingBatchCartEvent = () => {
        const {batchAddSkuEmail, batchAddSkuShipTo} = this.props;

        if (batchAddSkuEmail && batchAddSkuShipTo) {
            if (this.props.shoppingCartEvent) {
                this.props.shoppingCartEvent();
            } else {
                if (
                    this.props.history.location.pathname.toLocaleLowerCase() ===
                    '/purchase/shoppingCart'.toLocaleLowerCase()
                ) {
                    this.props.history.replace('/purchase/shoppingCart');
                } else {
                    this.props.history.push('/purchase/shoppingCart');
                }
            }
        } else {
            if (this.props.shoppingCartEvent) {
                this.props.shoppingCartEvent();
            }
        }
    };

    userIconEvent = () => {
        localStorage.setItem('changSkuTypeList', '');
        localStorage.setItem('offlineOrderCredential', []);
        if (this.props.userIconEvent) {
            this.props.userIconEvent();
        } else {
            if (loadIdToken()) {
                if (
                    this.props.history.location.pathname.toLocaleLowerCase() ===
                    '/userCenter'.toLocaleLowerCase()
                ) {
                    this.props.history.replace('/userCenter');
                } else {
                    localStorage.setItem('currentFinancialTabValue', '');
                    localStorage.setItem('currentOrderTabValue', '');
                    localStorage.setItem('currentExpressTabValue', '');
                    localStorage.setItem('currentSortResult', '');
                    localStorage.setItem('currentTodayPlanChecked', '');
                    if (
                        this.props.history.location.pathname ===
                        '/F1PackageReceive'
                    ) {
                        this.props.updateF1OrderReceiveSearchList({
                            queryKey: {$set: ''},
                        });
                    }
                    if (
                        this.props.history.location.pathname === '/F1OrderList'
                    ) {
                        this.props.updateF1OrderListSearchFields({
                            queryKey: {$set: ''},
                        });
                    }
                    this.props.history.push('/userCenter');
                }
            }
            // else {
            // 	this.props.history.push('/login');
            // }
        }
    };

    F1ShoppingCartEvent = () => {
        if (this.props.F1ShoppingCartEvent) {
            this.props.F1ShoppingCartEvent();
        }
    };

    backEvent = () => {
        localStorage.setItem('offlineOrderCredential', []);
        if (this.props.backEvent) {
            this.props.backEvent();
        } else {
            this.props.history.goBack();
        }
    };

    goto = (path) => this.props.history.push(path);

    exit = () => {
        removeIdToken();
        removeProfile();
        this.goto('/adminLogin');
    };

    backToHome = () => {
        this.props.history.push('/productList');
    };

    render() {
        const {
            cartCount,
            batchAddcartCount,
            hasNavigation,
            hasShoppingCart,
            hasUserCenter,
            hasF1ShoppingCart,
            hasBatchAddShoppingCart,
            f1CartCount,
            hasArrowBackIos,
            localData,
            noHomeButton,
            orderSubmitPage,
            batchAddSkuShipTo,
            ltoPageTitle,
            showTipIcon,
            isNoSupplyCenter,
            isOrderConfiramation,
            productSearcheFlag,
            testid,
        } = this.props;
        let isCustomer = localData.roleType === 0 ? true : false;

        return (
            <div className="header">
                <Grid
                    id="header-container"
                    className="header-container container-max-width is-fixed no-margin"
                    container
                    spacing={0}
                    justify={'space-between'}>
                    {hasArrowBackIos ? (
                        <Grid
                            className="back-icon"
                            item
                            xs={
                                showTipIcon ||
                                isNoSupplyCenter ||
                                productSearcheFlag
                                    ? 6
                                    : 4
                            }>
                            <IconButton
                                color="inherit"
                                testid={testid ? testid : ''}
                                onClick={this.backEvent.bind(this)}>
                                <ArrowBackIos />
                            </IconButton>
                            <label className="page-title">{ltoPageTitle}</label>
                            {showTipIcon && (
                                <HelpOutline
                                    onClick={this.props.openOnlineOrderDialog.bind(
                                        this,
                                    )}
                                />
                            )}
                        </Grid>
                    ) : (
                        <Grid className="left-home-icon" item xs={4}>
                            {typeof orderSubmitPage !== undefined &&
                            orderSubmitPage &&
                            isCustomer ? (
                                <IconButton
                                    className="home-icon"
                                    color="inherit"
                                    onClick={this.backToHome.bind(this)}>
                                    <Home />
                                </IconButton>
                            ) : null}
                        </Grid>
                    )}

                    <Grid
                        className="logo"
                        item
                        xs={
                            showTipIcon ||
                            isNoSupplyCenter ||
                            productSearcheFlag
                                ? 2
                                : 4
                        }>
                        {this.props.isOrderConfiramation ? (
                            <img
                                src={
                                    new URL(
                                        'Images/logo_top.png',
                                        import.meta.url,
                                    ).href
                                }
                                alt="Top Logo"></img>
                        ) : null}
                        {this.props.headerTitle}
                    </Grid>
                    <Grid className="account-icon" item xs={4}>
                        {hasNavigation ? (
                            <Navigation className="navigation">
                                <div className="username">{localData.name}</div>
                                {localData.roleType === 1 ? (
                                    <NavigationItem
                                        onClickOfSingleTap={() =>
                                            this.goto('/AdminF1OrderList')
                                        }
                                        className="link">
                                        {T('header_fone_order')}
                                    </NavigationItem>
                                ) : null}
                                {localData.roleType === 1 ? (
                                    <NavigationItem
                                        onClickOfSingleTap={() =>
                                            this.goto('/selectCustomer')
                                        }
                                        className="link">
                                        {T('header_select_customer')}
                                    </NavigationItem>
                                ) : null}
                                {localData.roleType === 2 ? (
                                    <NavigationItem
                                        onClickOfSingleTap={() =>
                                            this.goto('/shipmentList/toBeShip')
                                        }
                                        className="link">
                                        {T('header_delivery_management')}
                                    </NavigationItem>
                                ) : null}
                                {localData.roleType === 2 ? (
                                    <NavigationItem
                                        onClickOfSingleTap={() =>
                                            this.goto('/F1OrderList')
                                        }
                                        className="link">
                                        {T('header_fone_shippment_management')}
                                    </NavigationItem>
                                ) : null}
                                {localData.roleType === 1 ||
                                localData.roleType === 2 ? (
                                    <NavigationItem
                                        onClickOfSingleTap={() =>
                                            this.goto('/abnormalRecordList')
                                        }
                                        className="link">
                                        {T('header_abnormal_reagent_record')}
                                    </NavigationItem>
                                ) : null}
                                {/* { profile.type===1 || profile.type===2 ? <NavigationItem onClickOfSingleTap={ () => this.goto('/feedback') } className="link">反馈意见</NavigationItem> : null } */}
                                <NavigationItem
                                    onClickOfSingleTap={this.exit}
                                    className="link">
                                    {T('withdraw')}
                                </NavigationItem>
                            </Navigation>
                        ) : null}
                        {isCustomer && !noHomeButton ? (
                            <IconButton
                                className="home-icon"
                                color="inherit"
                                onClick={this.backToHome.bind(this)}>
                                <Home />
                            </IconButton>
                        ) : null}
                        {hasShoppingCart ? (
                            <IconButton
                                id="shippingcart-btn"
                                testid="shopping-cart-icon"
                                color="inherit"
                                onClick={this.shoppingCartEvent.bind(this)}>
                                <ShoppingCartOutlined />
                                {cartCount ? <sup>{cartCount}</sup> : null}
                            </IconButton>
                        ) : null}
                        {hasBatchAddShoppingCart ? (
                            <IconButton
                                id="shippingcart-btn"
                                testid="shopping-cart-icon"
                                color="inherit"
                                onClick={this.shoppingBatchCartEvent.bind(
                                    this,
                                )}>
                                <ShoppingCartOutlined />
                                {batchAddcartCount ? (
                                    <sup>{batchAddcartCount}</sup>
                                ) : null}
                            </IconButton>
                        ) : null}
                        {hasUserCenter ? (
                            <IconButton
                                color="inherit"
                                onClick={this.userIconEvent.bind(this)}>
                                <PersonOutlineOutlined />
                            </IconButton>
                        ) : null}
                        {hasF1ShoppingCart ? (
                            <IconButton
                                id="f1-shippingcart-btn"
                                color="inherit"
                                onClick={this.F1ShoppingCartEvent.bind(this)}>
                                <AddShoppingCart />
                                <sup>{f1CartCount || 0}</sup>
                            </IconButton>
                        ) : null}
                    </Grid>
                    <Grid
                        className="header-content lto-header-content"
                        item
                        xs={12}>
                        {this.props.children}
                    </Grid>
                </Grid>
                <div
                    id="header-background"
                    className={
                        batchAddSkuShipTo
                            ? 'batch-add-sku-header-background'
                            : ''
                    }></div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {auth, localData, notification} = state;
    return {
        auth: auth.data,
        msg: notification.msg,
        localData,
    };
};

const mapDispatchToProps = {
    openNotification,
    updateF1OrderReceiveSearchList,
    updateF1OrderListSearchFields,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
